import React from "react";
import { Router, Link } from "react-static";
import { hot } from "react-hot-loader";

import logoImg from "../assets/brand/black-center@2x.png";
import Social from "components/social.js";
import Menu from "components/menu.js";
import "../footer.css";

export const Footer = () => (
  <footer>
    <div className="wrapper">
      <div className="footer-logo">
        <Link to="/">
          <img src={logoImg} alt="" />
        </Link>
      </div>
      <nav>
        <Menu />
      </nav>

      <Social />
    </div>
  </footer>
);
export default Footer;



// WEBPACK FOOTER //
// /opt/build/repo/src/components/footer.js